module.exports = __webpack_public_path__ + "static/img/ag_8.ff009c1.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント2/ag_8.png
// module id = 884
// module chunks = 1